module.exports = __webpack_public_path__ + "img/bird_view.9b03c262.png";